var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content" }, [
    _c(
      "div",
      { staticClass: "tabs-container" },
      [
        _c(
          "el-tabs",
          {
            staticStyle: { width: "100%" },
            attrs: { "active-name": _vm.activeName, type: "card" }
          },
          [
            _c(
              "el-tab-pane",
              {
                attrs: {
                  name: "tabenglishDescriptionOfGoods",
                  label: _vm.$t("Information.EnglishProductName"),
                  lazy: true
                }
              },
              [_c("tab-sensitive-config", { attrs: { "word-field": 1 } })],
              1
            ),
            _c(
              "el-tab-pane",
              {
                attrs: {
                  name: "tabChineseDescriptionOfGoods",
                  label: _vm.$t("Information.ChineseProductName"),
                  lazy: true
                }
              },
              [_c("tab-sensitive-config", { attrs: { "word-field": 0 } })],
              1
            ),
            _c(
              "el-tab-pane",
              {
                attrs: {
                  name: "tabMark",
                  label: _vm.$t("Information.MarksAndNumbers"),
                  lazy: true
                }
              },
              [_c("tab-sensitive-config", { attrs: { "word-field": 2 } })],
              1
            ),
            _c(
              "el-tab-pane",
              {
                attrs: {
                  name: "tabShipper",
                  label: _vm.$t("Information.mailing"),
                  lazy: true
                }
              },
              [_c("tab-sensitive-config", { attrs: { "word-field": 3 } })],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }